import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import '../styles/index.scss';

// Import Components
import SidebarController from './components/sidebar';
import StepperController from './components/stepper';

// Import Features
import initDarkMode from './features/theme/dark-mode';
import initScrollUp from './features/accessibility/scroll-up';

// Namespace próprio para o Design System da PMV
window.PMV = {
  bootstrap,
};

// Initialize Features (Globais)
initDarkMode();
initScrollUp();

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Components
  // O Web Component <pmv-barra> se auto-registra no import acima.
  // Basta usá-lo no HTML: <pmv-barra></pmv-barra>

  new SidebarController().init();

  // Initialize Dynamic Components (Multiple instances)
  const steppers = document.querySelectorAll('[data-stepper]');
  steppers.forEach(stepper => {
    new StepperController(stepper);
  });

  // Global UI Initializations
  const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
  dropdownElementList.forEach(dropdownToggleEl => {
    new bootstrap.Dropdown(dropdownToggleEl);
  });
});
